import DataTableHeader from "@eisinc/MobiusOverrides/DataTable/DataTableHeader";

export default DataTableHeader;

export * from "@eisinc/MobiusOverrides/DataTable/DataTableHeader";
